const variantStyles = {
	neutral: 'bg-gray-100 text-gray-600 border-gray-200',
	blue: 'bg-blue-50 text-blue-800 border-blue-200',
	amber: 'bg-amber-50 text-amber-800 border-amber-200',
	green: 'bg-green-50 text-green-800 border-green-200',
	red: 'bg-red-50 text-red-800 border-red-200',
};

export const Badge = ({ variant = 'neutral', icon: Icon, tooltip, children }) => {
	return (
		<div className='group relative inline-flex'>
			<div
				className={`inline-flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-xs font-medium whitespace-nowrap ${variantStyles[variant]}`}
			>
				{Icon && <Icon size={13} />}
				{children}
			</div>
			{tooltip && (
				<div className='pointer-events-none absolute right-0 bottom-full z-10 mb-1.5 hidden group-hover:block'>
					<div className='rounded-md border border-gray-200 bg-white px-2 py-1 text-xs whitespace-nowrap text-gray-500 shadow-sm'>
						{tooltip}
					</div>
				</div>
			)}
		</div>
	);
};
